import "../styles/page_content.scss";
import "../styles/page_content_mobile.scss";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import {useSelector,useDispatch} from "react-redux";
import { selectAdescos,selectActivite ,setPage, selectPrestation} from "../features/counterSlice";
import {useState,useEffect} from "react";
import { RWebShare } from "react-web-share";
import Share from "../components/Share";

const PageContent=()=>{
    const dispatch=useDispatch();
    const p=useSelector(selectPrestation);

    const [data,set_data]=useState(null);
    useEffect(()=>{
        dispatch(setPage(-1));
    },[])

    useEffect(()=>{
        if(p==null) return;
        
        set_data(p);
    },[p])


    return(
        <>
            <Nav />
            <div className="page_content relative">
            
                <div className="content relative">
                    
                <h2>{data?.title.rendered}</h2>
                <img src={data?.acf.image.url} />
                
                <div   dangerouslySetInnerHTML={{__html:data?.acf.details}}/>

                {data!=null && <Share 
                item={data}
                title={data?.title.rendered}
                url="https://ongadesco.org" 
                text={data?.acf.a_propos} />}

                </div>
            <Footer />
        </div>
        </>
        
    );
}
export default PageContent;